import { render, staticRenderFns } from "./publishStoreModal.vue?vue&type=template&id=0b23f752&scoped=true"
import script from "./publishStoreModal.vue?vue&type=script&lang=js"
export * from "./publishStoreModal.vue?vue&type=script&lang=js"
import style0 from "./publishStoreModal.vue?vue&type=style&index=0&id=0b23f752&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b23f752",
  null
  
)

export default component.exports